import { render, staticRenderFns } from "./TitlePosition.vue?vue&type=template&id=36c5773c&scoped=true"
import script from "./TitlePosition.vue?vue&type=script&lang=js"
export * from "./TitlePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5773c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c5773c')) {
      api.createRecord('36c5773c', component.options)
    } else {
      api.reload('36c5773c', component.options)
    }
    module.hot.accept("./TitlePosition.vue?vue&type=template&id=36c5773c&scoped=true", function () {
      api.rerender('36c5773c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/TitlePosition.vue"
export default component.exports